import { useIsMutating } from '@tanstack/react-query';

import { ESHOP_MUTATION_KEY } from '@telialt/core-eshop/src/model';

export const useIsLeasingPlanMutating = () => {
    const isDeletingLeasingPlan = useIsMutating({ mutationKey: [ESHOP_MUTATION_KEY.DELETE_LEASING_PLAN], exact: true });
    const isAddingLeasingPlan = useIsMutating({ mutationKey: [ESHOP_MUTATION_KEY.ADD_LEASING_PLAN], exact: true });

    return Boolean(isDeletingLeasingPlan || isAddingLeasingPlan);
};
